import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-start pl-5 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-[28px] text-v_dark_blue" }, "Como podemos te ajudar?", -1)
const _hoisted_3 = { class: "grid grid-cols-[1fr_3%_1fr] mt-10" }
const _hoisted_4 = { class: "w-full px-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-[28px] text-v_dark_blue" }, "Tópicos de ajuda:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "border-r-v_gray border-r-2 h-full w-0" }, null, -1)
const _hoisted_7 = { class: "text-v_dark_blue" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "text-[28px]" }, "Envie sua dúvida:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-[18px] mt-3" }, "Assunto:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-[18px] mt-3 mb-2" }, "Qual seria a sua dúvida?", -1)
const _hoisted_11 = { class: "mb-5" }

import { Paragraph, Input, TextArea, ModalButton } from "../atoms"
import { answers } from "../../utils/FAQAnswer"
import { ref, reactive } from "vue"
import { watch } from "vue"
import { IEmail, IResaleDetails } from "@/utils/interfaces"
import { sendEmailToTax } from "@/repositories/sendMailer"
import { useStore } from "@/store"
import { Notification } from "@/utils/enum"


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqInternal',
  emits: ["enableLoading", "emailSent", "emitError"],
  setup(__props, { emit }) {

const store = useStore()



const resaleInfo: IResaleDetails = store.getters.getUserRev

let panel = ref()
let showButton = ref(false)

let contentEmail = reactive({
	subject: "",
	content: "",
	email: resaleInfo.email,
	resale: resaleInfo.name,
	username: resaleInfo.username,
	codRev: resaleInfo.codRev,
})

watch(contentEmail, () => {
	let validate = []

	for (const key in contentEmail) {
		if (contentEmail[key as keyof IEmail] != "") {
			validate.push(key)
		}
	}

	if (validate.length == 6) {
		showButton.value = true
	} else {
		showButton.value = false
	}
})

const questions = ref([
	{
		title: "1. Como solicitar minhas comissões",
		response: answers.getCommissions,
	},

	{
		title: "2. Como posso trocar minha senha?",
		response: answers.changePassword,
	},
	{
		title: "3. Usuário incorreto ",
		response: answers.wrongUser,
	},
	{
		title: "4. Alteração de dados bancários ",
		response: answers.bankDetailsChanges,
	},
])

const sendEmail = async () => {
	emit("enableLoading", true)

	const res: any = await sendEmailToTax(contentEmail)

	if (res?.status == 201) {
		emit(
			"emailSent",
			true,
			Notification.TITLE_DOUBT_SENT,
			Notification.SUBTITLE_DOUBT_SENT
		)
	} else {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}

	contentEmail.content = ""
	contentEmail.subject = ""

	emit("enableLoading", false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_unref(Paragraph), { class: "text-v_gray3 mt-2" }, {
        default: _withCtx(() => [
          _createTextVNode(" Escolha um topico ou utilize o formulário para realizar sua pergunta ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_v_expansion_panels, {
          modelValue: _unref(panel),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(panel) ? (panel).value = $event : panel = $event)),
          disabled: false,
          multiple: "",
          class: "mt-3 mb-8 z-0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (items, index) => {
              return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(items.title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.response, (response, index) => {
                    return (_openBlock(), _createBlock(_component_v_expansion_panel_text, { key: index }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(response), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createVNode(_unref(Input), {
          placeholder: "Digite o assunto!  Ex:”Comissões”",
          w: "100%",
          class: "mt-2",
          modelValue: _unref(contentEmail).subject,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(contentEmail).subject) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_10,
        _createVNode(_unref(TextArea), {
          rows: 4,
          placeholder: "Digite sua duvida!",
          modelValue: _unref(contentEmail).content,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(contentEmail).content) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(ModalButton), {
            "enable-button": _unref(showButton),
            disabled: !_unref(showButton),
            w: "17rem",
            h: "3.18rem",
            class: "!rounded-[0.5rem] active:scale-90",
            onClick: sendEmail
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Enviar pergunta ")
            ]),
            _: 1
          }, 8, ["enable-button", "disabled"])
        ])
      ])
    ])
  ], 64))
}
}

})